import { useState, useEffect } from 'react';
import './earning.css';
import { getTodayEarningsSummary } from '../../../../shared/actions/transactionAction';
import { formatUsdAmountDisplay } from '../../../../shared/utils/function';
import { TIME_PERIOD_OPTIONS } from '../../../../shared/constants/EarningsPayout';
import { CALCULATE_DATE_RANGE } from '../../../../shared/utils/earningsPayoutUtil';
import { ROLE } from '../../../../shared/constants/common';

const TotalEarningsTodayCard = ({
    user
}) => {
    const [selectedTimePeriod, setSelectedTimePeriod] = useState('Today');
    const [{ startDate, endDate }, setDateRange] = useState(() => CALCULATE_DATE_RANGE('Today'));
    const [todayEarnings, setTodayEarnings] = useState(null);
    const [loading, setLoading] = useState(true);

    const handleSelectedTimePeriod = async (event) => {
        const period = event.target.value;
        setSelectedTimePeriod(period);
        setDateRange(CALCULATE_DATE_RANGE(period));
    };

    useEffect(() => {
        const fetchTodayEarnings = async () => {
            setLoading(true);
            const result = await getTodayEarningsSummary(startDate, endDate);
            if (result.success) {
                setTodayEarnings(result.data);
            }
            setLoading(false);
        };

        fetchTodayEarnings();
    }, [startDate, endDate]);

    const percentageChange = todayEarnings?.percentageChangeFromYesterday || 0;
    const isPositiveChange = percentageChange >= 0;

    return (
        <div className="g_card text-center">
            <div className="mb-2 d-flex justify-content-center align-items-center gap-3">
                <p className="mb-0">Total Earnings</p>
                <div className='with_down_arrow'>
                    <select
                        value={selectedTimePeriod}
                        onChange={handleSelectedTimePeriod}
                        className="form-select total-earnings-select"
                    >
                        {TIME_PERIOD_OPTIONS.map(item => (
                            <option key={item} value={item}>
                                {item}
                            </option>
                        ))}
                    </select>
                    <i className="fa-solid fa-chevron-down"></i>
                </div>
            </div>

            {loading ? (
                <div className="modern-referral-stats-loading">
                    <div className="modern-referral-stats-spinner"></div>
                    <p className="modern-referral-stats-loading-text">Loading...</p>
                </div>
            ) : (
                <>
                    <h1>
                        ${formatUsdAmountDisplay(todayEarnings?.totalEarningsToday || 0)}
                    </h1>

                    <div className="d-flex flex-column gap-3 align-items-center">
                        {selectedTimePeriod !== 'All time' && (
                            <p className="sm_text_card_round text-no-wrap">
                                <span>
                                    <i className={`fa-solid fa-arrow-${isPositiveChange ? 'up' : 'down'}`}></i>
                                    {isPositiveChange ? '+' : ''}
                                    {percentageChange}% from {selectedTimePeriod}
                                </span>
                            </p>
                        )}
                        <p className="sm_text_card_round">
                            <span>
                                <i className="fa-solid fa-user-plus"></i>{' '}
                                {user?.rol === ROLE.CREATOR_SUB ? 'Subscribers' : 'Followers'}{' '}
                                gained {todayEarnings?.subscribersGained || 0}
                            </span>
                        </p>
                    </div>
                </>
            )}
        </div>
    );
};

export default TotalEarningsTodayCard;